import { I18n } from '@boschebike/ebds-js';
import React, { useContext } from 'react';
import { Page, PageNavigation, PageNavigationRouterLink } from '../../components';
import { dataActServiceRoutes, termsOfUseRoutes } from '../../config/router';
import { DATA_ACT_LOCATIONS } from '../../config/routerLocations';
import { PlatformContext } from '../../context/platformContext';
import { DxfIntegrationContext } from '../../context/dxfIntegrationContext';
import { RoutingContext } from '../../context/routingContext';
import { useContent } from '../../hooks/use-content';

const ServicePage = ({ routes, activeTab }: { routes: PageNavigationRouterLink[], activeTab: string }) => {
  const currentRoute = routes.find((route) => route.route.endsWith(activeTab));
  const Component = currentRoute?.component || routes[0].component;
  return <Component />;
};

export const DataActServicesPage = () => {
  const content: I18n = useContent();
  const platformContext = useContext(PlatformContext);
  const dxfIntegrationContext = useContext(DxfIntegrationContext);
  const { isLoaded, activeTab, setTab } = useContext(RoutingContext);
  const routes = dataActServiceRoutes(content);

  React.useEffect(() => {
    if (isLoaded && !activeTab) {
      setTab(DATA_ACT_LOCATIONS.GENERAL);
    }
  }, [isLoaded, activeTab]);

  return (
    <Page
      links={termsOfUseRoutes(content, { isDPASupported: dxfIntegrationContext.isDPASupported, isDXF: platformContext.isDXF })}
      enforcedTabId='600'
    >
      <PageNavigation links={routes} />
      <ServicePage routes={routes} activeTab={activeTab} />
    </Page>
  );
};
